import React from 'react'
import Link from 'gatsby-link'
import logo from '../images/logo.svg'
import styled from 'styled-components'

const LogoImage = styled.img`
  display: block;
  margin: 0;
`

class Logo extends React.Component {
  render() {
    let lang = this.props.currentLanguage

    if (lang == 'fi')
      lang = ""

    const homeUrl = "/" + lang

    return(
      <Link to={homeUrl}>
        <LogoImage src={logo} alt="Poliisimuseo" />
      </Link>
    )
  }
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/logo.js